export default __webpack_public_path__ + "static/media/Front-Private-Palace-in-Kawtharyt-El-Sayed.f3519028.jpg";